module.exports = __webpack_public_path__ + "csv_templates/parent-2b49e41e9d02e822e5e7a4952ba67700.csv";